module.exports = __webpack_public_path__ + "img/159_thumbnail.3a4d70e4.jpg";